'use client';
/**
 * Проверяет, исполняется ли код в контексте браузера.
 */ var isBrowser = function() {
    return typeof window !== "undefined" && typeof window.document !== "undefined";
};

export { isBrowser };
